import React from 'react';
import RichTextA11yWrapper from 'helpers/RichTextA11yWrapper/RichTextA11yWrapper';
import { Marketing } from 'lib/templates/Feature.BOKF.model';

type LayoutProps = Marketing.DataTemplates.EmbedVideo;

export type VideoBlockProps = {
  params: {
    AnchorId?: string;
    HeadingType?: {
      Styles: {
        value: string;
      };
      Tag: {
        value: string;
      };
    };
  };
} & LayoutProps;

const VideoBlock = (props: VideoBlockProps): JSX.Element => {
  const headingTag = props.params?.HeadingType?.Tag.value.length
    ? props.params?.HeadingType?.Tag.value
    : 'h2';
  const hasTitleUnderline =
    props.params?.HeadingType?.Styles?.value.includes('title-border') || false;
  const hasThickUnderline = props.params?.HeadingType?.Styles?.value.includes('thick');

  return (
    <>
      <RichTextA11yWrapper
        className="rtaw mt-4 md:mt-6 lg:mt-10"
        tag={headingTag}
        field={props.fields?.Title}
      />
      {hasTitleUnderline && (
        <div
          className={`${
            hasThickUnderline ? 'border-b-[5px]' : 'border-b-[3px]'
          } mt-2 border-light-stroke-secondary-brand w-[3rem]`}
        ></div>
      )}

      <RichTextA11yWrapper
        field={props.fields?.VideoEmbed}
        tag="div"
        className="my-4 lg:my-6 lg:w-3/4 mx-auto"
        id={props.params?.AnchorId}
      ></RichTextA11yWrapper>

      <RichTextA11yWrapper
        field={props.fields?.CopyText}
        tag="div"
        className="p2 mt-4 lg:mt-6"
      ></RichTextA11yWrapper>
    </>
  );
};

export default VideoBlock;
